import React from "react";
import BrandIcon from "../assets/BrandIcon.png"
const Footer = () => {
  return (
    <footer className="w-full bg-[color:var(--brand)] text-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={BrandIcon}
                alt="Qualityzone"
                className="h-10 w-auto"
              />
            </div>

            <p className="mt-5 text-sm text-white/80 max-w-md">
              Qualityzone LLC connects quality professionals worldwide through
              training and consulting services designed to strengthen compliance,
              performance, and continuous improvement.
            </p>

            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-lg px-4 py-3 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:opacity-95 transition"
              >
                Get in Touch
              </a>
              <a
                href="/services"
                className="inline-flex items-center justify-center rounded-lg px-4 py-3 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
              >
                Explore Services
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              <div>
                <div className="text-sm font-semibold text-white">Company</div>
                <div className="mt-4 flex flex-col gap-3 text-sm">
                  <a className="text-white/80 hover:text-white transition" href="/">Home</a>
                  <a className="text-white/80 hover:text-white transition" href="/services">Services</a>
                  <a className="text-white/80 hover:text-white transition" href="/contact">Contact</a>
                  <a className="text-white/80 hover:text-white transition" href="/about">About</a>
                </div>
              </div>

              <div>
                <div className="text-sm font-semibold text-white">Resources</div>
                <div className="mt-4 flex flex-col gap-3 text-sm">
                  <a className="text-white/80 hover:text-white transition" href="/book">Book a Call</a>
                  <a className="text-white/80 hover:text-white transition" href="/blog">Blog</a>
                  <a className="text-white/80 hover:text-white transition" href="/faq">FAQ</a>
                </div>
              </div>

              <div>
                <div className="text-sm font-semibold text-white">Contact</div>
                <div className="mt-4 flex flex-col gap-3 text-sm text-white/80">
                  <div>
                    <div className="text-white/90 font-medium">Email</div>
                    <div>mrizwan@qualityzoneus.com</div>
                  </div>
                  <div>
                    <div className="text-white/90 font-medium">Phone</div>
                    <div>+1 (248) 202-8143</div>
                  </div>
                  <div>
                    <div className="text-white/90 font-medium">Location</div>
                    <div>United States</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-t border-white/15 pt-6">
  <div className="text-xs text-white/70">
    © {new Date().getFullYear()} Qualityzone LLC. All rights reserved.
  </div>

              <div className="flex items-center gap-6 text-xs">
                <a className="text-white/70 hover:text-white transition" href="#privacy">Privacy</a>
                <a className="text-white/70 hover:text-white transition" href="#terms">Terms</a>
                <a className="text-white/70 hover:text-white transition" href="#accessibility">Accessibility</a>
                <a
                  href="https://delbric.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition"
                >
                  Powered by Delbric Systems
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;